// extracted by mini-css-extract-plugin
module.exports =  {"navigation-arrow":"cJRZCdE","navigationArrow":"cJRZCdE","left-arrow":"NG33CR1","leftArrow":"NG33CR1","right-arrow":"YoqWx4a","rightArrow":"YoqWx4a"};